export default {
    lang: 'English',
    'company-login': 'تسجيل شركات',
    'forsa-title': 'فرصة بيع ومقايضة',
    'forsa-about': 'نقوم بتبسيط الشراء والبيع والمقايضة مع حلول <br> تكنولوجية شاملة ومتطورة',

    "footer": {
    "links": {
      "about-us": "نحن",
      "about-forsa": "عن فرصة",
      "our-vision": "رؤيتنا",
      "our-mission": "مهامنا",
      "our-message": "رسالتنا",
      "faqs": "الأسئلة الشائعة",
      "policies": "السياسات",
      "contact-details": "بيانات التواصل",
      "safety-and-security": "السلامة والأمان",
      "how-does-it-work?": "كيف تعمل؟",
      "terms-conditions": "الشروط والأحكام",
      "privacy-policy": "سياسة الخصوصية",
      "contact-us": "تواصل معنا"
    },
    "copyrights": "حقوق النشر {year} © فرصة. جميع الحقوق محفوظة"
  },
}